import AuthMixin from '@/components/mixins/auth-mixin'
import PlanCardDiscovery from './plan-card-discovery/plan-card-discovery-tmpl'
import PlanCardPremium from './plan-card-premium/plan-card-premium-tmpl'
import PlanUpgrade from './plan-upgrade/plan-upgrade-tmpl'
import _ from 'lodash'
import { useMixpanel } from '@base-shared/composables/use-mixpanel'

export default {
  name: 'plans',
  inject: [
    '$currentUser',
    '$utils'
  ],
  components: {
    PlanCardDiscovery,
    PlanCardPremium,
    PlanUpgrade
  },
  props: {},
  mixins: [AuthMixin],
  data () {
    return {
      isCheckingCurrentPlan: false,
      triggerCancelButtonInPremiumPlanCard: { status: false, ref: 0 },
      userInfo: null,
      planUpgradeWizardOpen: false
    }
  },
  watch: {},
  computed: {},
  methods: {
    handleClosePlanUpgradeDialog () {
      this.planUpgradeWizardOpen = false

      // Clear route if url has datatrans response data
      if (!_.isEmpty(this.$route.query.datatransRedirect) && !_.isEmpty(this.$route.query.refno)) {
        this.$router.push('/plans')
      }
    },
    async checkCurrentPlan () {
      this.isCheckingCurrentPlan = true
      await this.$currentUser.getUserInfoFromBackend({
        callback: (userInfo) => {
          this.$utils.mainLoader(false)
          this.isCheckingCurrentPlan = false
          const currentPlan = userInfo._edit ? userInfo._edit.plan.currentPlan : null
          if (currentPlan !== this.$utils.options.plans.DISCOVERY && !this.$utils.isPageForLicenses()) {
            this.$router.push('/menu')
          }
        }
      })
    }
  },
  mounted () {
    this.isAuthenticated({
      callback: () => {
        useMixpanel().track('Plan page')
        this.checkCurrentPlan()
      }
    })
  }
}
